import { Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { Box } from '@material-ui/core';

interface NoRecordsProps {
  className?: string;
  text?: string;
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle1' | 'subtitle2' | 'body1' | 'body2' | 'caption' | 'button' | 'overline' | 'srOnly' | 'inherit';
  color?: 'initial' | 'inherit' | 'primary' | 'secondary' | 'textPrimary' | 'textSecondary' | 'error';
  height?: number | string;
}
const NoRecords: FC<NoRecordsProps> = ({ className, text, variant = 'h5', color = 'textPrimary', height = 'auto', ...rest }) => {
  return (
    <>
      <Box p={2} textAlign={'center'} height={height} display={'flex'} flexDirection={'column'} justifyContent={'center'}>
        <Typography
          variant={variant}
          color={color}
        >
          {text}
        </Typography>

      </Box>
    </>
  );
};

export default NoRecords;
